export default [
  {
    // 应用列表页
    path: '/company-core',
    name: 'companyCore',
    meta: {
      group: 'companyCore'
    },
    component: () => import(/* webpackChunkName: "CompanyCore" */ '../views/company-core/list')
  },
  {
    // 应用申请页
    // ?client_id=xxx 表示编辑
    path: '/company-core/add',
    name: 'companyCoreAdd',
    meta: {
      group: 'companyCore'
    },
    component: () => import(/* webpackChunkName: "CompanyCoreAdd" */ '../views/company-core/add')
  },
  {
    //应用申请完成页面
    path: '/company-core/add/complete',
    name: 'companyCoreAddComplete',
    meta: {
      group: 'companyCore'
    },
    component: () => import(/* webpackChunkName: "CompanyCoreAdd" */ '../views/company-core/add-complete')
  },
  {
    // 应用详情页
    path: '/company-core/:client_id/detail',
    name: 'companyCoreDetail',
    meta: {
      group: 'companyCore'
    },
    component: () => import(/* webpackChunkName: "CompanyCoreDetail" */ '../views/company-core/detail')
  },
  {
    // 应用 api 组页
    path: '/company-core/:client_id/scope',
    name: 'companyCoreScope',
    meta: {
      group: 'companyCore'
    },
    component: () => import(/* webpackChunkName: "CompanyCoreScope" */ '../views/company-core/scope')
  },
  {
    // 企业账号管理页面
    path: '/company-core/account',
    name: 'companyCoreAccount',
    meta: {
      group: 'companyCore'
    },
    component: () => import(/* webpackChunkName: "CompanyCoreAccount" */ '../views/company-core/account')
  }
]
